/**
 * Generated by orval v8.16.0 🍺
 * Do not edit manually.
 * FinPath API
 * Backend API programu FinPath (panel admina + aplikacja mobilna).
 * OpenAPI spec version: 0.1.0
 */

export type V1ClassesListState = typeof V1ClassesListState[keyof typeof V1ClassesListState];


export const V1ClassesListState = {
  active: 'active',
  all: 'all',
  archived: 'archived',
  deleted: 'deleted',
} as const;
